import { render, staticRenderFns } from "./betalok_lab.vue?vue&type=template&id=3948f62e&scoped=true"
import script from "./betalok_lab.vue?vue&type=script&lang=js"
export * from "./betalok_lab.vue?vue&type=script&lang=js"
import style0 from "./betalok_lab.vue?vue&type=style&index=0&id=3948f62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948f62e",
  null
  
)

export default component.exports